import type { CSSProperties } from 'react';

interface TextFieldProps {
  value?: string;
  placeholder?: string;
  label?: string;
  className?: string;
  style?: CSSProperties;
}

export function TextFieldView({
  value = '',
  placeholder,
  label,
  className,
  style,
}: TextFieldProps) {
  return (
    <div className={`flex flex-col gap-1${className ? ` ${className}` : ''}`} style={style}>
      {label && <label className="text-xs text-muted-foreground">{label}</label>}
      <input
        type="text"
        value={value}
        readOnly
        placeholder={placeholder}
        className="rounded-md border border-input bg-card px-3 py-1.5 text-sm text-foreground"
      />
    </div>
  );
}
